import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { THEMES, Logo } from '@nsd/fe';
import { useSelector } from 'react-redux';

const NSD_LOGO_URL = 'https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Logos/Qore_Q_white_icon.png';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
        boxShadow: 'none',
        backgroundColor: theme.palette.primary.main,
      }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
        backgroundColor: theme.palette.background.default,
      }
      : {}),
  },
  toolbar: {
    minHeight: 64,
  },
  textHeadings: {
    color: '#fff',
  },
}));

/**
 * TopBar menu for geolocation screen for unauthenticated routes
 */
function TopBar({
  className,
  hidden,
}) {
  const classes = useStyles();
  const { appName, appVersion, type } = useSelector(
    (state) => state.application
  );
  if (!type || hidden) return null;

  return (
    <AppBar className={clsx(classes.root, className)}>
      <Toolbar className={classes.toolbar}>
        <Logo image={NSD_LOGO_URL} altText="NSD Logo" />
        <Box ml={2}>
          <Typography variant="h3" className={classes.textHeadings}>
            {appName}
          </Typography>
          <Typography variant="caption" className={classes.textHeadings}>
            Version
            {' '}
            {appVersion}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  /**
   * Class name to apply to the outer most container element in
   * TopBar
   */
  className: PropTypes.string,
  /**
   * Weather or not to hide the TopBar entirely. Used when
   * the app is a plugin for Twilio Flex as an example
   */
  hidden: PropTypes.bool,
};

TopBar.defaultProps = {
  hidden: false,
  className: '',
};

export default TopBar;
